<section class="case-studies-hero">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="hero-content">
                    <span class="hero-badge">Real-World Success Stories</span>
                    <h1 class="hero-title">Case Studies</h1>
                    <p class="hero-description">Discover how our cutting-edge NVIDIA H200, H100, and A100 GPU solutions are powering innovation across diverse industries, delivering exceptional performance and cost savings.</p>
                    
                    <div class="hero-stats">
                        <div class="stat-item">
                            <div class="stat-number">150+</div>
                            <div class="stat-label">Projects Delivered</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">99.9%</div>
                            <div class="stat-label">Client Satisfaction</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">40%</div>
                            <div class="stat-label">Avg. Cost Savings</div>
                        </div>
                    </div>
                    
                    <div class="hero-actions">
                        <a class="btn-primary-gradient me-3" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            Schedule a Demo
                        </a>
                        <a class="btn-outline-light" routerLink="/sign-up">
                            <i class="bx bx-cloud"></i>
                            Start Free Trial
                        </a>
                    </div>
                    
                    <div class="hero-features">
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Industry Expertise</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Proven Results</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Measurable ROI</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="hero-image">
                    <div class="image-decoration">
                        <div class="floating-card card-1">
                            <i class="bx bx-trending-up"></i>
                            <span>Performance Boost</span>
                        </div>
                        <div class="floating-card card-2">
                            <i class="bx bx-analyse"></i>
                            <span>Data Analytics</span>
                        </div>
                        <div class="floating-card card-3">
                            <i class="bx bx-line-chart"></i>
                            <span>ROI Focused</span>
                        </div>
                    </div>
                    <img src="assets/img/case-studies-hero.png" alt="Case Studies" class="img-fluid main-image">
                </div>
            </div>
        </div>
    </div>
    <div class="hero-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
    </div>
</section>

<section class="case-studies-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span class="section-badge">Industry Solutions</span>
            <h2>Transforming Industries with AI</h2>
            <p>Explore how our NVIDIA H200, H100, and A100 GPU solutions are powering innovation across diverse sectors.</p>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="industry-filter text-center mb-5">
                    <div class="filter-container">
                        <button class="filter-btn active" data-filter="all">All Industries</button>
                        <button class="filter-btn" data-filter="healthcare">Healthcare</button>
                        <button class="filter-btn" data-filter="finance">Finance</button>
                        <button class="filter-btn" data-filter="ecommerce">E-commerce</button>
                        <button class="filter-btn" data-filter="manufacturing">Manufacturing</button>
                        <button class="filter-btn" data-filter="education">Education</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row case-studies-grid">
            <!-- Case Study 1 -->
            <div class="col-lg-4 col-md-6 mb-4 case-study-card" data-category="healthcare">
                <div class="case-study-item">
                    <div class="service-header">
                        <div class="service-icon">
                            <i class="bx bx-plus-medical"></i>
                        </div>
                        <div class="service-badge healthcare">Healthcare</div>
                    </div>
                    <div class="service-content">
                        <h3>AI-Powered Diagnostics Platform</h3>
                        <p class="client">MediTech Solutions Pvt. Ltd.</p>
                        <p class="service-description">Deployed NVIDIA H100 GPU cluster for real-time medical image analysis, reducing diagnosis time by 75%.</p>
                        
                        <div class="service-features">
                            <ul class="feature-list">
                                <li><i class="bx bx-check"></i> 75% faster diagnosis</li>
                                <li><i class="bx bx-check"></i> 40% cost reduction</li>
                                <li><i class="bx bx-check"></i> Real-time analysis</li>
                            </ul>
                        </div>
                        
                        <div class="service-specs">
                            <div class="spec-grid">
                                <div class="spec-item">
                                    <span class="spec-label">Processing Speed:</span>
                                    <span class="spec-value">10x faster</span>
                                </div>
                                <div class="spec-item">
                                    <span class="spec-label">Accuracy:</span>
                                    <span class="spec-value">99.2%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Case Study 2 -->
            <div class="col-lg-4 col-md-6 mb-4 case-study-card" data-category="finance">
                <div class="case-study-item">
                    <div class="service-header">
                        <div class="service-icon">
                            <i class="bx bx-credit-card"></i>
                        </div>
                        <div class="service-badge finance">Finance</div>
                    </div>
                    <div class="service-content">
                        <h3>Fraud Detection System</h3>
                        <p class="client">SecureBank Ltd.</p>
                        <p class="service-description">Implemented real-time fraud detection using machine learning models, improving accuracy by 92%.</p>
                        
                        <div class="service-features">
                            <ul class="feature-list">
                                <li><i class="bx bx-check"></i> 92% detection accuracy</li>
                                <li><i class="bx bx-check"></i> 60% faster response</li>
                                <li><i class="bx bx-check"></i> Real-time monitoring</li>
                            </ul>
                        </div>
                        
                        <div class="service-specs">
                            <div class="spec-grid">
                                <div class="spec-item">
                                    <span class="spec-label">False Positives:</span>
                                    <span class="spec-value">Reduced by 70%</span>
                                </div>
                                <div class="spec-item">
                                    <span class="spec-label">Transactions/sec:</span>
                                    <span class="spec-value">50K+</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Case Study 3 -->
            <div class="col-lg-4 col-md-6 mb-4 case-study-card" data-category="ecommerce">
                <div class="case-study-item">
                    <div class="service-header">
                        <div class="service-icon">
                            <i class="bx bx-cart"></i>
                        </div>
                        <div class="service-badge ecommerce">E-commerce</div>
                    </div>
                    <div class="service-content">
                        <h3>Scalable Retail Platform</h3>
                        <p class="client">ShopEasy India</p>
                        <p class="service-description">Built auto-scaling infrastructure to handle 10x traffic during peak sales periods without downtime.</p>
                        
                        <div class="service-features">
                            <ul class="feature-list">
                                <li><i class="bx bx-check"></i> 10x traffic handling</li>
                                <li><i class="bx bx-check"></i> 99.99% uptime</li>
                                <li><i class="bx bx-check"></i> Auto-scaling</li>
                            </ul>
                        </div>
                        
                        <div class="service-specs">
                            <div class="spec-grid">
                                <div class="spec-item">
                                    <span class="spec-label">Peak Traffic:</span>
                                    <span class="spec-value">500K users</span>
                                </div>
                                <div class="spec-item">
                                    <span class="spec-label">Response Time:</span>
                                    <span class="spec-value">< 100ms</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Case Study 4 -->
            <div class="col-lg-4 col-md-6 mb-4 case-study-card" data-category="manufacturing">
                <div class="case-study-item">
                    <div class="service-header">
                        <div class="service-icon">
                            <i class="bx bx-cog"></i>
                        </div>
                        <div class="service-badge manufacturing">Manufacturing</div>
                    </div>
                    <div class="service-content">
                        <h3>IoT Predictive Maintenance</h3>
                        <p class="client">Precision Manufacturing Co.</p>
                        <p class="service-description">Deployed edge computing solution with real-time analytics to predict equipment failures 85% accurately.</p>
                        
                        <div class="service-features">
                            <ul class="feature-list">
                                <li><i class="bx bx-check"></i> 85% prediction accuracy</li>
                                <li><i class="bx bx-check"></i> 30% downtime reduction</li>
                                <li><i class="bx bx-check"></i> Real-time analytics</li>
                            </ul>
                        </div>
                        
                        <div class="service-specs">
                            <div class="spec-grid">
                                <div class="spec-item">
                                    <span class="spec-label">Equipment Monitored:</span>
                                    <span class="spec-value">200+ units</span>
                                </div>
                                <div class="spec-item">
                                    <span class="spec-label">Maintenance Cost:</span>
                                    <span class="spec-value">Reduced by 40%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Case Study 5 -->
            <div class="col-lg-4 col-md-6 mb-4 case-study-card" data-category="education">
                <div class="case-study-item">
                    <div class="service-header">
                        <div class="service-icon">
                            <i class="bx bx-book"></i>
                        </div>
                        <div class="service-badge education">Education</div>
                    </div>
                    <div class="service-content">
                        <h3>Virtual Learning Platform</h3>
                        <p class="client">Global University</p>
                        <p class="service-description">Created scalable virtual classroom infrastructure supporting 50,000+ concurrent students with low latency.</p>
                        
                        <div class="service-features">
                            <ul class="feature-list">
                                <li><i class="bx bx-check"></i> 50K+ concurrent users</li>
                                <li><i class="bx bx-check"></i> 50ms avg. latency</li>
                                <li><i class="bx bx-check"></i> Scalable infrastructure</li>
                            </ul>
                        </div>
                        
                        <div class="service-specs">
                            <div class="spec-grid">
                                <div class="spec-item">
                                    <span class="spec-label">Classrooms:</span>
                                    <span class="spec-value">1000+</span>
                                </div>
                                <div class="spec-item">
                                    <span class="spec-label">Uptime:</span>
                                    <span class="spec-value">99.95%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Case Study 6 -->
            <div class="col-lg-4 col-md-6 mb-4 case-study-card" data-category="healthcare">
                <div class="case-study-item">
                    <div class="service-header">
                        <div class="service-icon">
                            <i class="bx bx-dna"></i>
                        </div>
                        <div class="service-badge healthcare">Healthcare</div>
                    </div>
                    <div class="service-content">
                        <h3>Genomic Data Analysis</h3>
                        <p class="client">BioResearch Institute</p>
                        <p class="service-description">Built high-performance computing cluster for genomic sequencing, reducing processing time from weeks to hours.</p>
                        
                        <div class="service-features">
                            <ul class="feature-list">
                                <li><i class="bx bx-check"></i> 100x faster processing</li>
                                <li><i class="bx bx-check"></i> 99.9% data accuracy</li>
                                <li><i class="bx bx-check"></i> HPC cluster</li>
                            </ul>
                        </div>
                        
                        <div class="service-specs">
                            <div class="spec-grid">
                                <div class="spec-item">
                                    <span class="spec-label">Data Processed:</span>
                                    <span class="spec-value">10TB/day</span>
                                </div>
                                <div class="spec-item">
                                    <span class="spec-label">Processing Time:</span>
                                    <span class="spec-value">Reduced by 95%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="cta-section ptb-100">
    <div class="container">
        <div class="cta-content-wrapper">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="cta-content">
                        <h2>Transform Your Business with Cloud GPU Solutions</h2>
                        <p class="cta-description">Join hundreds of enterprises leveraging our cloud GPU solutions for AI/ML workloads. Experience unprecedented performance and cost savings.</p>
                        
                        <div class="cta-features">
                            <div class="feature-item">
                                <i class="bx bx-time"></i>
                                <span>Deploy in 60 seconds</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-support"></i>
                                <span>24/7 Expert Support</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-shield-check"></i>
                                <span>99.99% Uptime SLA</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="cta-actions">
                        <a class="btn-cta-primary" routerLink="/sign-up">
                            <i class="bx bx-cloud"></i>
                            <span>Start Free Trial</span>
                            <small>No credit card required</small>
                        </a>
                        <a class="btn-cta-secondary" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            <span>Schedule Demo</span>
                            <small>See our platform</small>
                        </a>
                        
                        <div class="cta-guarantee">
                            <i class="bx bx-badge-check"></i>
                            <span>99.99% Uptime Guaranteed</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="cta-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
        <div class="bg-element element-4"></div>
    </div>
</section>